export class GitEnvVariables {
    branch: string;
    pipelineUrl; string;
    envName: string;
    env: string;
    versionHash: string;
}